import axios from "axios";
import { getAuthToken } from "../helpers/userDetails";

// const API_URL = "http://localhost:8118/api/v1";
const API_URL = "https://backend-api.twingehealth.com/api/v1";
interface ApiResponse<T> {
  responseData: T;
}
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

export const axiosGet = async <T>(url: string): Promise<T> => {
  try {
    const response = await axiosInstance.get<ApiResponse<T>>(url);

    const res = response.data.responseData; // TypeScript will infer the type

    if (!res) {
      throw new Error(`Server Error: No response data`);
    }

    return res;
  } catch (error) {
    handleAxiosError(error); // Handle errors
    throw new Error("An error occurred during the GET request."); // Re-throw the error
  }
};

// Function to handle POST requests
export const axiosPost = async <T, U>(url: string, body: T): Promise<U> => {
  try {
    const response = await axiosInstance.post<U>(url, body);
    const res = response.data;
    if (!res) {
      throw new Error(`Server Error: No response data`);
    }
    return res; // Return response data
  } catch (error) {
    handleAxiosError(error); // Handle errors
    throw new Error("An error occurred during the POST request."); // Re-throw the error
  }
};

// Function to handle Axios errors
const handleAxiosError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    throw error.response
      ? error.response.data.message || "Server Error"
      : error.message; // Handle Axios errors
  }
  throw new Error("An unknown error occurred."); // Handle other errors
};
